import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MDBBootstrapModulePro } from 'libs/mdbootstrap/typescripts/pro/index';
import { MDBBootstrapModule } from 'libs/mdbootstrap/typescripts/free/index';
import { ModalModule } from 'app/modal/modal.module';
import { CoreModule } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { NewsFeedComponent } from 'app/home/newsFeed/newsFeed.component';
import { LookupService } from 'app/core/lookup/lookup.service';



@NgModule({
  imports: [
    MDBBootstrapModule,
    MDBBootstrapModulePro,
    CommonModule,
    TranslateModule,
    CoreModule,
    SharedModule,
    ModalModule
  ],
  declarations: [
    NewsFeedComponent
  ],
  providers: [
    LookupService
  ],
  exports: [
    NewsFeedComponent
  ]
})
export class NewsFeedModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/home/newsFeed/newsFeed.module.ts